module.exports = __webpack_public_path__ + "images/103_4096.jpg";